export type Preset = '30d' | '90d' | '12m' | 'all' | 'custom'

export function getRange(preset: Preset, customFrom: string, customTo: string) {
  const today = new Date()
  const fmt   = (d: Date) => d.toISOString().split('T')[0]
  const to    = fmt(today)

  if (preset === 'all')    return { from: null as string | null, to: null as string | null }
  if (preset === 'custom') return { from: customFrom || null, to: customTo || null }

  const from = new Date(today)
  if (preset === '30d') from.setDate(from.getDate() - 30)
  if (preset === '90d') from.setDate(from.getDate() - 90)
  if (preset === '12m') from.setFullYear(from.getFullYear() - 1)
  return { from: fmt(from), to }
}

const PRESETS: { label: string; value: Preset }[] = [
  { label: 'Last 30 days',    value: '30d' },
  { label: 'Last 90 days',    value: '90d' },
  { label: 'Last 12 months',  value: '12m' },
  { label: 'All time',        value: 'all' },
  { label: 'Custom',          value: 'custom' },
]

export function DateFilter({
  preset, setPreset, customFrom, setCustomFrom, customTo, setCustomTo,
}: {
  preset: Preset; setPreset: (p: Preset) => void
  customFrom: string; setCustomFrom: (s: string) => void
  customTo: string;   setCustomTo:   (s: string) => void
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex gap-1 bg-gray-100 p-1 rounded-lg">
        {PRESETS.map(p => (
          <button
            key={p.value}
            onClick={() => setPreset(p.value)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors cursor-pointer ${
              preset === p.value ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      {preset === 'custom' && (
        <div className="flex items-center gap-2 text-sm">
          <input
            type="date"
            value={customFrom}
            onChange={e => setCustomFrom(e.target.value)}
            className="h-9 rounded-md border border-input bg-white px-3 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          />
          <span className="text-gray-400">to</span>
          <input
            type="date"
            value={customTo}
            onChange={e => setCustomTo(e.target.value)}
            className="h-9 rounded-md border border-input bg-white px-3 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          />
        </div>
      )}
    </div>
  )
}
